/* ============================================================
   CUSTOM PREMIUM CART  —  custom-cart.js
   Real Shopify AJAX cart. Quantity +/- , remove, clear — all
   without page reload. Totals + summary re-rendered live via the
   Section Rendering API (section=<id>). Checkout / Buy It Now use
   native Shopify (form submit + dynamic checkout buttons).
   ============================================================ */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.__ccInit) return;
    root.__ccInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var cfg = (window.CustomCartConfig && window.CustomCartConfig[sectionId]) || {
      routes: {
        cartChange: '/cart/change.js',
        cartUpdate: '/cart/update.js',
        cartClear: '/cart/clear.js',
        cart: '/cart'
      },
      text: {}
    };
    var text = cfg.text || {};

    var toastEl = root.querySelector('[data-cart-toast]');
    var toastTimer;
    function toast(msg) {
      if (!toastEl || !msg) return;
      toastEl.textContent = msg;
      toastEl.hidden = false;
      requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('is-visible');
        setTimeout(function () { toastEl.hidden = true; }, 300);
      }, 2200);
    }

    /* ---- Update the mini-cart bubble in the header ---- */
    function updateHeaderCount(count) {
      document.querySelectorAll('.cart-badge, [data-cart-count], .cart-count-bubble')
        .forEach(function (el) { el.textContent = count; });
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {}
    }

    /* ---- Re-render this whole section from the server ---- */
    function rerender(cartState) {
      updateHeaderCount(cartState.item_count);

      if (cartState.item_count === 0) {
        // Reload to show the (server-rendered) empty state cleanly
        window.location.assign(cfg.routes.cart);
        return;
      }

      var url = cfg.routes.cart + '?section_id=' + sectionId;
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-root]');
          if (!fresh) return;

          // Swap items
          var oldItems = root.querySelector('[data-cart-items]');
          var newItems = fresh.querySelector('[data-cart-items]');
          if (oldItems && newItems) oldItems.replaceWith(newItems);

          // Swap summary
          var oldSum = root.querySelector('[data-cart-summary]');
          var newSum = fresh.querySelector('[data-cart-summary]');
          if (oldSum && newSum) oldSum.replaceWith(newSum);

          // Swap sticky bar total
          root.querySelectorAll('[data-cart-total]').forEach(function (el) {
            var match = fresh.querySelector('[data-cart-total]');
            if (match) el.textContent = match.textContent;
          });

          bindItemEvents();
        });
    }

    /* ---- Change a line quantity by key ---- */
    function changeLine(key, quantity) {
      setBusy(key, true);
      return fetch(cfg.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cartState) {
          return Promise.resolve(rerender(cartState)).then(function () {
            return cartState;
          });
        })
        .catch(function () { setBusy(key, false); });
    }

    function setBusy(key, busy) {
      var item = root.querySelector('[data-line-key="' + cssEscape(key) + '"]');
      if (!item) return;
      var wrap = item.closest('[data-cart-item]');
      if (!wrap) return;
      var qty = wrap.querySelector('[data-quantity-wrapper]');
      if (qty) qty.classList.toggle('is-loading', busy);
    }

    function cssEscape(v) {
      return String(v).replace(/["\\]/g, '\\$&');
    }

    /* ---- Bind per-item controls (re-run after each rerender) ---- */
    function bindItemEvents() {
      root.querySelectorAll('[data-cart-item]').forEach(function (item) {
        if (item.__bound) return;
        item.__bound = true;

        var key = item.getAttribute('data-line-key');
        var input = item.querySelector('[data-qty-input]');
        var minus = item.querySelector('[data-qty-minus]');
        var plus = item.querySelector('[data-qty-plus]');
        var remove = item.querySelector('[data-remove-item]');

        if (minus) minus.addEventListener('click', function () {
          var v = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          input.value = v;
          changeLine(key, v);
        });
        if (plus) plus.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 0) + 1;
          input.value = v;
          changeLine(key, v);
        });
        if (input) {
          var commit = function () {
            var v = Math.max(0, parseInt(input.value, 10) || 0);
            input.value = v;
            changeLine(key, v);
          };
          input.addEventListener('change', commit);
          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); commit(); }
          });
        }
        if (remove) remove.addEventListener('click', function () {
          item.classList.add('is-removing');
          setTimeout(function () {
            changeLine(key, 0).then(function () { toast(text.removed || 'Item removed'); });
          }, 200);
        });
      });
    }

    /* ---- Clear cart ---- */
    var clearBtn = root.querySelector('[data-clear-cart]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var msg = text.confirmClear || 'Remove all items from your cart?';
        if (!window.confirm(msg)) return;
        fetch(cfg.routes.cartClear, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (cartState) {
            toast(text.cleared || 'Cart cleared');
            rerender(cartState);
          });
      });
    }

    bindItemEvents();
  }

  function boot() {
    document.querySelectorAll('[data-cart-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-init
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cart-root]');
    if (root) { root.__ccInit = false; initRoot(root); }
  });
})();
